<template>
  <div>
    <h1 class="title is-1">
      Vous n'avez pas accès à cette page.
    </h1>
  </div>
</template>

<script>
export default {
  name: 'Forbidden'
}
</script>
